import { createTelemetry, createTelemetryObject } from '@shared/core';

const category = 'CreateAccount';

export const createAccountTelemetry = createTelemetryObject({
  actions: {
    createAccountClicked: eventType => ({ action: 'CreateAccountCTA', actionType: 'click', category, extraInfo: { CtaName: 'EmailPassword', eventType } }),
    trackError: (eventType, action: string, error: unknown) => ({ action, actionType: 'error', category, extraInfo: { error, eventType } }),
    emailClicked: eventType => ({ action: 'Email', actionType: 'click', category, label: 'createaccount', extraInfo: { eventType } }),
    passwordClicked: eventType => ({ action: 'Password', actionType: 'click', category, label: 'createaccount', extraInfo: { eventType } })
  },
  pages: {}
});

const { TelemetryProvider, useTelemetry: useCreateAccountTelemetry } = createTelemetry(createAccountTelemetry);

export { TelemetryProvider, useCreateAccountTelemetry };
